// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-promo {
  --dp-promo-ink: #232933;
  --dp-promo-yellow: #ffd335;
  --dp-promo-yellow-deep: #ffc800;
  --dp-promo-blue: #3054f1;
  --dp-promo-orange: #ff8400;
  --dp-promo-navy: #202b6d;
  --dp-promo-pink: #e92b64;
  --dp-promo-sky: #def8ff;
  --dp-promo-display-font: "Bricolage Grotesque", "Plus Jakarta Sans", sans-serif;
  --dp-promo-body-font: "Plus Jakarta Sans", sans-serif;
  --dp-promo-scale: 1;
}

.dp-promo-datecard {
  position: relative;
  flex: none;
  width: calc(62.52px * var(--dp-promo-scale));
  height: calc(62.52px * var(--dp-promo-scale));
  border-radius: calc(4.31px * var(--dp-promo-scale));
  background: #ffffff;
  overflow: hidden;
  font-family: var(--dp-promo-display-font);
}

.dp-promo-datecard-month {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(18.3px * var(--dp-promo-scale));
  background: var(--dp-promo-month-bg, var(--dp-promo-blue));
  color: #ffffff;
  font-size: calc(12.93px * var(--dp-promo-scale));
  line-height: calc(16.82px * var(--dp-promo-scale));
  font-weight: 600;
  letter-spacing: 0;
}

.dp-promo-datecard-day {
  position: absolute;
  top: calc(11.62px * var(--dp-promo-scale));
  left: 0;
  right: 0;
  text-align: center;
  color: var(--dp-promo-ink);
  font-size: calc(38.8px * var(--dp-promo-scale));
  line-height: calc(50.45px * var(--dp-promo-scale));
  font-weight: 900;
}

.dp-promo-pill {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 0 0;
  border-radius: 999px;
  font-family: var(--dp-promo-display-font);
  white-space: nowrap;
}

.dp-promo-strip {
  --dp-promo-strip-bg: var(--dp-promo-yellow);
  --dp-promo-month-bg: var(--dp-promo-blue);
  --dp-promo-free-bg: var(--dp-promo-orange);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  padding: 0 80px;
  background: var(--dp-promo-strip-bg);
  box-sizing: border-box;
  overflow: hidden;
}

.dp-promo-strip-inner {
  display: flex;
  align-items: center;
  gap: 72px;
}

.dp-promo-strip-lead {
  display: flex;
  align-items: center;
  gap: 32px;
}

.dp-promo-strip-close {
  position: absolute;
  top: 16px;
  right: 80px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.dp-promo-strip-close img {
  width: 24px;
  height: 24px;
}

.dp-promo-strip-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dp-promo-strip-title {
  margin: 0;
  color: var(--dp-promo-ink);
  font-family: var(--dp-promo-display-font);
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 700;
  letter-spacing: -0.56px;
}

.dp-promo-strip-title-mark {
  color: var(--dp-promo-blue);
}

.dp-promo-strip-sub {
  margin: 0;
  color: var(--dp-promo-ink);
  font-family: var(--dp-promo-body-font);
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 400;
  letter-spacing: 0;
}

.dp-promo-strip-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  gap: 8px;
  height: 44px;
  padding: 0 24px;
  border: 0;
  border-radius: 999px;
  background: var(--dp-promo-ink);
  color: #ffffff;
  font-family: var(--dp-promo-body-font);
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 600;
  letter-spacing: 0.16px;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
}

.dp-promo-strip-cta:hover,
.dp-promo-strip-cta:focus {
  color: #ffffff;
  text-decoration: none;
}

.dp-promo-strip-cta-icon {
  width: 24px;
  height: 24px;
}

.dp-promo-countdown {
  display: flex;
  flex: none;
  align-items: flex-start;
  gap: calc(6.3px * var(--dp-promo-scale));
}

.dp-promo-countdown-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(55px * var(--dp-promo-scale));
}

.dp-promo-countdown-tile {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(49.8px * var(--dp-promo-scale));
  border-radius: calc(4.8px * var(--dp-promo-scale));
  background: linear-gradient(180deg, #3054f1 0%, #003bc6 6.2%, #427bff 100%);
}

.dp-promo-countdown-tile::before,
.dp-promo-countdown-tile::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 0;
  height: 0;
  border-top: calc(3.2px * var(--dp-promo-scale)) solid transparent;
  border-bottom: calc(3.2px * var(--dp-promo-scale)) solid transparent;
  transform: translateY(-50%);
}

.dp-promo-countdown-tile::before {
  left: 0;
  border-left: calc(6.4px * var(--dp-promo-scale)) solid var(--dp-promo-strip-bg);
}

.dp-promo-countdown-tile::after {
  right: 0;
  border-right: calc(6.4px * var(--dp-promo-scale)) solid var(--dp-promo-strip-bg);
}

.dp-promo-countdown-value {
  color: #ffffff;
  font-family: var(--dp-promo-body-font);
  font-size: calc(24.8px * var(--dp-promo-scale));
  line-height: calc(37.2px * var(--dp-promo-scale));
  font-weight: 600;
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
}

.dp-promo-countdown-label {
  margin-top: calc(7.6px * var(--dp-promo-scale));
  color: var(--dp-promo-ink);
  font-family: var(--dp-promo-body-font);
  font-size: calc(12px * var(--dp-promo-scale));
  line-height: calc(9px * var(--dp-promo-scale));
  font-weight: 400;
}

.dp-promo-badge {
  position: relative;
  flex: none;
  width: 92px;
  height: 74.06px;
}

.dp-promo-badge .dp-promo-datecard {
  position: absolute;
  top: 2.14px;
  left: 0;
}

.dp-promo-badge-icon {
  position: absolute;
}

.dp-promo-badge-icon--lock {
  left: 55.36px;
  top: 17.46px;
  width: 38.69px;
  height: 36.93px;
}

.dp-promo-badge-free {
  left: 33.04px;
  top: 58.95px;
  width: 56.89px;
  height: 17.49px;
  transform: rotate(-9.62deg);
  background: var(--dp-promo-free-bg, var(--dp-promo-orange));
  color: var(--dp-promo-ink);
  font-size: 13.57px;
  line-height: 17.49px;
  font-weight: 900;
}

.dp-promo-card-wrap {
  width: 100%;
  max-width: 854px;
  container-type: inline-size;
}

.dp-promo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-height: 133px;
  padding: 16px 107px 16px 71px;
  border-radius: 16px;
  background: var(--dp-promo-yellow);
  box-sizing: border-box;
  overflow: hidden;
}

.dp-promo-card-blob {
  position: absolute;
  left: 59.2%;
  top: 107.22px;
  width: 329.48px;
  height: 153.08px;
  border-radius: 50%;
  background: var(--dp-promo-yellow-deep);
  transform-origin: 0 0;
  transform: rotate(-37.386deg);
  pointer-events: none;
}

.dp-promo-card-title {
  position: relative;
  flex: 0 0 auto;
  margin: 0;
  width: 339px;
  max-width: 100%;
  color: var(--dp-promo-ink);
  font-size: 28px;
  line-height: 36.4px;
  font-weight: 700;
}

.dp-promo-illus {
  position: relative;
  flex: none;
  width: 213px;
  height: 101px;
}

.dp-promo-illus .dp-promo-datecard {
  position: absolute;
  left: 13px;
  top: 4px;
  border-radius: 5.29px;
  transform: rotate(11.28deg);
  transform-origin: 0 0;
}

.dp-promo-illus-free {
  left: 67px;
  top: 31.23px;
  width: 103.2px;
  height: 31.73px;
  transform: rotate(-9.62deg);
  background: var(--dp-promo-orange);
  color: var(--dp-promo-ink);
  font-size: 24.18px;
  line-height: 31.44px;
  font-weight: 900;
}

.dp-promo-illus-class {
  left: 118.8px;
  top: 43.94px;
  width: 99.13px;
  height: 30.13px;
  transform: rotate(11.51deg);
  background: var(--dp-promo-navy);
  color: #ffffff;
  font-size: 21.16px;
  line-height: 27.51px;
  font-weight: 800;
}

.dp-promo-illus-spark {
  position: absolute;
  left: 161.68px;
  top: -4.18px;
  width: 26.21px;
  height: 29.95px;
}

.dp-promo-illus-lock {
  position: absolute;
  left: 64.36px;
  top: 54.37px;
  width: 49.64px;
  height: 46.42px;
}

@container (max-width: 800px) {
  .dp-promo-card {
    padding: 16px 24px 16px 32px;
  }
}

@container (max-width: 640px) {
  .dp-promo-card {
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    text-align: center;
  }

  .dp-promo-card-title {
    width: auto;
    max-width: none;
  }
}

@container (max-width: 420px) {
  .dp-promo-card-title {
    font-size: 22px;
    line-height: 28.6px;
  }
}

@media (max-width: 1200px) {
  .dp-promo-strip {
    padding: 0 24px;
  }

  .dp-promo-strip-inner {
    gap: 32px;
  }

  .dp-promo-strip-close {
    right: 24px;
  }
}

@media (max-width: 900px) {
  .dp-promo-strip {
    height: auto;
    min-height: 100px;
    padding: 16px 24px;
  }

  .dp-promo-strip-inner {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .dp-promo-strip-lead {
    flex-direction: column;
    gap: 16px;
  }

  .dp-promo-strip-copy {
    align-items: center;
  }

  .dp-promo-strip-title {
    font-size: 22px;
    line-height: 28.6px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/Passes/PassPromo.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,+EAA+E;EAC/E,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4CAA4C;EAC5C,6CAA6C;EAC7C,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,0DAA0D;EAC1D,cAAc;EACd,gDAAgD;EAChD,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,+CAA+C;EAC/C,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4CAA4C;EAC5C,kDAAkD;EAClD,2EAA2E;AAC7E;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,iEAAiE;EACjE,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,+EAA+E;AACjF;;AAEA;EACE,QAAQ;EACR,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,+CAA+C;EAC/C,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,sCAAsC;EACtC,6CAA6C;EAC7C,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,2DAA2D;EAC3D,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;AAEF","sourcesContent":[".dp-promo {\n  --dp-promo-ink: #232933;\n  --dp-promo-yellow: #ffd335;\n  --dp-promo-yellow-deep: #ffc800;\n  --dp-promo-blue: #3054f1;\n  --dp-promo-orange: #ff8400;\n  --dp-promo-navy: #202b6d;\n  --dp-promo-pink: #e92b64;\n  --dp-promo-sky: #def8ff;\n  --dp-promo-display-font: \"Bricolage Grotesque\", \"Plus Jakarta Sans\", sans-serif;\n  --dp-promo-body-font: \"Plus Jakarta Sans\", sans-serif;\n  --dp-promo-scale: 1;\n}\n\n.dp-promo-datecard {\n  position: relative;\n  flex: none;\n  width: calc(62.52px * var(--dp-promo-scale));\n  height: calc(62.52px * var(--dp-promo-scale));\n  border-radius: calc(4.31px * var(--dp-promo-scale));\n  background: #ffffff;\n  overflow: hidden;\n  font-family: var(--dp-promo-display-font);\n}\n\n.dp-promo-datecard-month {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(18.3px * var(--dp-promo-scale));\n  background: var(--dp-promo-month-bg, var(--dp-promo-blue));\n  color: #ffffff;\n  font-size: calc(12.93px * var(--dp-promo-scale));\n  line-height: calc(16.82px * var(--dp-promo-scale));\n  font-weight: 600;\n  letter-spacing: 0;\n}\n\n.dp-promo-datecard-day {\n  position: absolute;\n  top: calc(11.62px * var(--dp-promo-scale));\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: var(--dp-promo-ink);\n  font-size: calc(38.8px * var(--dp-promo-scale));\n  line-height: calc(50.45px * var(--dp-promo-scale));\n  font-weight: 900;\n}\n\n.dp-promo-pill {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform-origin: 0 0;\n  border-radius: 999px;\n  font-family: var(--dp-promo-display-font);\n  white-space: nowrap;\n}\n\n.dp-promo-strip {\n  --dp-promo-strip-bg: var(--dp-promo-yellow);\n  --dp-promo-month-bg: var(--dp-promo-blue);\n  --dp-promo-free-bg: var(--dp-promo-orange);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100px;\n  padding: 0 80px;\n  background: var(--dp-promo-strip-bg);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.dp-promo-strip-inner {\n  display: flex;\n  align-items: center;\n  gap: 72px;\n}\n\n.dp-promo-strip-lead {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.dp-promo-strip-close {\n  position: absolute;\n  top: 16px;\n  right: 80px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.dp-promo-strip-close img {\n  width: 24px;\n  height: 24px;\n}\n\n.dp-promo-strip-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dp-promo-strip-title {\n  margin: 0;\n  color: var(--dp-promo-ink);\n  font-family: var(--dp-promo-display-font);\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 700;\n  letter-spacing: -0.56px;\n}\n\n.dp-promo-strip-title-mark {\n  color: var(--dp-promo-blue);\n}\n\n.dp-promo-strip-sub {\n  margin: 0;\n  color: var(--dp-promo-ink);\n  font-family: var(--dp-promo-body-font);\n  font-size: 16px;\n  line-height: 22.4px;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n\n.dp-promo-strip-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  gap: 8px;\n  height: 44px;\n  padding: 0 24px;\n  border: 0;\n  border-radius: 999px;\n  background: var(--dp-promo-ink);\n  color: #ffffff;\n  font-family: var(--dp-promo-body-font);\n  font-size: 16px;\n  line-height: 22.4px;\n  font-weight: 600;\n  letter-spacing: 0.16px;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.dp-promo-strip-cta:hover,\n.dp-promo-strip-cta:focus {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.dp-promo-strip-cta-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.dp-promo-countdown {\n  display: flex;\n  flex: none;\n  align-items: flex-start;\n  gap: calc(6.3px * var(--dp-promo-scale));\n}\n\n.dp-promo-countdown-unit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: calc(55px * var(--dp-promo-scale));\n}\n\n.dp-promo-countdown-tile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: calc(49.8px * var(--dp-promo-scale));\n  border-radius: calc(4.8px * var(--dp-promo-scale));\n  background: linear-gradient(180deg, #3054f1 0%, #003bc6 6.2%, #427bff 100%);\n}\n\n.dp-promo-countdown-tile::before,\n.dp-promo-countdown-tile::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 0;\n  height: 0;\n  border-top: calc(3.2px * var(--dp-promo-scale)) solid transparent;\n  border-bottom: calc(3.2px * var(--dp-promo-scale)) solid transparent;\n  transform: translateY(-50%);\n}\n\n.dp-promo-countdown-tile::before {\n  left: 0;\n  border-left: calc(6.4px * var(--dp-promo-scale)) solid var(--dp-promo-strip-bg);\n}\n\n.dp-promo-countdown-tile::after {\n  right: 0;\n  border-right: calc(6.4px * var(--dp-promo-scale)) solid var(--dp-promo-strip-bg);\n}\n\n.dp-promo-countdown-value {\n  color: #ffffff;\n  font-family: var(--dp-promo-body-font);\n  font-size: calc(24.8px * var(--dp-promo-scale));\n  line-height: calc(37.2px * var(--dp-promo-scale));\n  font-weight: 600;\n  letter-spacing: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.dp-promo-countdown-label {\n  margin-top: calc(7.6px * var(--dp-promo-scale));\n  color: var(--dp-promo-ink);\n  font-family: var(--dp-promo-body-font);\n  font-size: calc(12px * var(--dp-promo-scale));\n  line-height: calc(9px * var(--dp-promo-scale));\n  font-weight: 400;\n}\n\n.dp-promo-badge {\n  position: relative;\n  flex: none;\n  width: 92px;\n  height: 74.06px;\n}\n\n.dp-promo-badge .dp-promo-datecard {\n  position: absolute;\n  top: 2.14px;\n  left: 0;\n}\n\n.dp-promo-badge-icon {\n  position: absolute;\n}\n\n.dp-promo-badge-icon--lock {\n  left: 55.36px;\n  top: 17.46px;\n  width: 38.69px;\n  height: 36.93px;\n}\n\n.dp-promo-badge-free {\n  left: 33.04px;\n  top: 58.95px;\n  width: 56.89px;\n  height: 17.49px;\n  transform: rotate(-9.62deg);\n  background: var(--dp-promo-free-bg, var(--dp-promo-orange));\n  color: var(--dp-promo-ink);\n  font-size: 13.57px;\n  line-height: 17.49px;\n  font-weight: 900;\n}\n\n.dp-promo-card-wrap {\n  width: 100%;\n  max-width: 854px;\n  container-type: inline-size;\n}\n\n.dp-promo-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  width: 100%;\n  min-height: 133px;\n  padding: 16px 107px 16px 71px;\n  border-radius: 16px;\n  background: var(--dp-promo-yellow);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.dp-promo-card-blob {\n  position: absolute;\n  left: 59.2%;\n  top: 107.22px;\n  width: 329.48px;\n  height: 153.08px;\n  border-radius: 50%;\n  background: var(--dp-promo-yellow-deep);\n  transform-origin: 0 0;\n  transform: rotate(-37.386deg);\n  pointer-events: none;\n}\n\n.dp-promo-card-title {\n  position: relative;\n  flex: 0 0 auto;\n  margin: 0;\n  width: 339px;\n  max-width: 100%;\n  color: var(--dp-promo-ink);\n  font-size: 28px;\n  line-height: 36.4px;\n  font-weight: 700;\n}\n\n.dp-promo-illus {\n  position: relative;\n  flex: none;\n  width: 213px;\n  height: 101px;\n}\n\n.dp-promo-illus .dp-promo-datecard {\n  position: absolute;\n  left: 13px;\n  top: 4px;\n  border-radius: 5.29px;\n  transform: rotate(11.28deg);\n  transform-origin: 0 0;\n}\n\n.dp-promo-illus-free {\n  left: 67px;\n  top: 31.23px;\n  width: 103.2px;\n  height: 31.73px;\n  transform: rotate(-9.62deg);\n  background: var(--dp-promo-orange);\n  color: var(--dp-promo-ink);\n  font-size: 24.18px;\n  line-height: 31.44px;\n  font-weight: 900;\n}\n\n.dp-promo-illus-class {\n  left: 118.8px;\n  top: 43.94px;\n  width: 99.13px;\n  height: 30.13px;\n  transform: rotate(11.51deg);\n  background: var(--dp-promo-navy);\n  color: #ffffff;\n  font-size: 21.16px;\n  line-height: 27.51px;\n  font-weight: 800;\n}\n\n.dp-promo-illus-spark {\n  position: absolute;\n  left: 161.68px;\n  top: -4.18px;\n  width: 26.21px;\n  height: 29.95px;\n}\n\n.dp-promo-illus-lock {\n  position: absolute;\n  left: 64.36px;\n  top: 54.37px;\n  width: 49.64px;\n  height: 46.42px;\n}\n\n@container (max-width: 800px) {\n  .dp-promo-card {\n    padding: 16px 24px 16px 32px;\n  }\n}\n\n@container (max-width: 640px) {\n  .dp-promo-card {\n    flex-direction: column;\n    gap: 24px;\n    padding: 24px;\n    text-align: center;\n  }\n\n  .dp-promo-card-title {\n    width: auto;\n    max-width: none;\n  }\n}\n\n@container (max-width: 420px) {\n  .dp-promo-card-title {\n    font-size: 22px;\n    line-height: 28.6px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .dp-promo-strip {\n    padding: 0 24px;\n  }\n\n  .dp-promo-strip-inner {\n    gap: 32px;\n  }\n\n  .dp-promo-strip-close {\n    right: 24px;\n  }\n}\n\n@media (max-width: 900px) {\n  .dp-promo-strip {\n    height: auto;\n    min-height: 100px;\n    padding: 16px 24px;\n  }\n\n  .dp-promo-strip-inner {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .dp-promo-strip-lead {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .dp-promo-strip-copy {\n    align-items: center;\n  }\n\n  .dp-promo-strip-title {\n    font-size: 22px;\n    line-height: 28.6px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
